import router from '@/router'

export const isBranded = (query) => {
	const { branded } = query ? query : router.app.$route.query

	return branded === '1'
}
